let instance = null;
class JsUtil {
    constructor(){
        if(instance) return instance;
        instance = this;
    }

    /*
    * 스타일 클래스에 상태 클래스 추가. 상태값 외의 클래스가 있을 경우 삭제.
    * [params]
    * selector : selector명
    * value : 상태값 '' or 'disabled' or 'complete'
    *  */
    state(selector,value){
        switch (value){
            case 'disabled':
                document.querySelector(selector).classList.remove('complete');
                document.querySelector(selector).classList.add('disabled');
                break;

            case 'complete':
                document.querySelector(selector).classList.remove('disabled');
                document.querySelector(selector).classList.add('complete');
                break;

            case '':
            case undefined:
            case null:
                document.querySelector(selector).classList.remove('disabled');
                document.querySelector(selector).classList.remove('complete');
                break;

        }
    }

    /*
    * DOM 엘리먼트에 텍스트 기입.
    * [params]
    * id : id명
    * value : 기입할 텍스트
    *  */
    inputText(id, value){
        let tag = document.getElementById(id).tagName;
        switch (tag){
            case 'INPUT':
            document.getElementById(id).setAttribute('value', value);
            break;

            default:
            document.getElementById(id).textContent = value;
            break;
        }
    }
}

export default JsUtil;